<script setup lang="ts">
import { defineProps } from "vue";
import BlogCard from "@/views/Blogs/components/BlogCard/BlogCard.vue";
import { BlogCardItem } from "@/types/blogs";

const props = defineProps<{
  blogList: BlogCardItem[];
}>();
</script>

<template>
  <div
    class="cards-grid gap-x-[32px] gap-y-[36px] px-1 my-4 md:mb-6 xl:mb-10 md:mt-10 justify-center sm:grow"
  >
    <BlogCard
      :blog="blogCard"
      v-for="blogCard in props.blogList"
      :key="blogCard.id"
    />
  </div>
</template>

<style scoped>
.cards-grid {
  @apply grid
    grid-cols-[repeat(auto-fill,calc(100%-16px))]
    md:grid-cols-[repeat(auto-fill,246px)]
    xl:grid-cols-[repeat(auto-fill,396px)];
}
</style>
